import { Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { PERMISSIONS } from './core/constants/permissions.constants';

export const APP_ROUTES: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: 'app',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes')
          .then(m => m.DASHBOARD_ROUTES),
      },
      {
        path: 'imports',
        canActivate: [permissionGuard],
        data: { permissions: [PERMISSIONS.IMPORTS_ACCESS] },
        loadChildren: () => import('./features/imports/imports.routes')
          .then(m => m.IMPORTS_ROUTES),
      },
      {
        path: 'exports',
        canActivate: [permissionGuard],
        data: { permissions: [PERMISSIONS.EXPORTS_ACCESS] },
        loadChildren: () => import('./features/exports/exports.routes')
          .then(m => m.EXPORTS_ROUTES),
      },
      {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.routes')
          .then(m => m.ADMIN_ROUTES),
      },
      {
        path: 'chat',
        canActivate: [permissionGuard],
        data: { permissions: [PERMISSIONS.CHAT_USE, PERMISSIONS.CHAT_VIEW] },
        loadChildren: () => import('./features/chat/chat.routes')
          .then(m => m.CHAT_ROUTES),
      },
      {
        path: 'configuration',
        loadChildren: () => import('./features/configuration/configuration.routes')
          .then(m => m.CONFIGURATION_ROUTES),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'auth/sing-in',
  },
];
